import styled, { css } from 'styled-components';
import { ifProp, switchProp } from 'styled-tools';

import Button from '@prisjakt/ui-button';

import { Position } from './types';

type FeedbackButtonProps = {
  position: Position;
};

export const FeedbackButton = styled(Button)<FeedbackButtonProps>`
  && {
    z-index: 4;
    transform-origin: 100% 100%;
    visibility: ${ifProp('hidden', 'hidden', 'visible')};

    ${switchProp('position', {
      inline: css`
        position: relative;
        transform: none;
      `,
      right: css`
        position: fixed;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        transform: rotate(-90deg) translateX(50%);
        right: 0;
        bottom: 50%;
      `,
      'bottom-right': css`
        position: fixed;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        transform: none;
        right: 20px;
        bottom: 0;
      `,
    })};
  }
`;
